import { Button, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { FormDialog, FormLayout, FormItem, Input } from "@formily/antd";
import { createSchemaField } from "@formily/react";
import { setting as settingService } from "@/services";
const schema = {
  type: "object",
  properties: {
    content: {
      type: "string",
      title: "敏感词",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
  },
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
  },
});

function WordStockEditButton({ wordId, token, callback }) {
  return (
    <FormDialog.Portal>
      <Button
        icon={<EditOutlined />}
        size="small"
        onClick={() => {
          FormDialog({ title: "修改" }, "modal-dialog", () => {
            return (
              <FormLayout labelCol={6} wrapperCol={16}>
                <SchemaField
                  schema={schema}
                  scope={{
                    token,
                  }}
                />
              </FormLayout>
            );
          })
            .forOpen((payload, next) => {
              settingService.getWordStock(wordId, token).then((data) => {
                next({
                  initialValues: {
                    content: data?.content,
                  },
                });
              });
            })
            .forConfirm((payload, next) => {
              settingService
                .updateWordStock(wordId, payload.values, token)
                .then((res) => {
                  message.success("修改成功");
                  callback(Date.now());
                })
                .catch((err) => {
                  message.error(err.message || err);
                })
                .finally(() => {
                  next(payload);
                });
            })
            .open();
        }}
      />
    </FormDialog.Portal>
  );
}

export default WordStockEditButton;
